<template>
  <a-config-provider :locale="antLocale">
    <template #empty="scope">
      <Empty :width="100" v-bind="scope" />
    </template>
    <router-view />
  </a-config-provider>
</template>

<script setup>
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn'
import enUS from '@arco-design/web-vue/es/locale/lang/en-us'
import { useAppStore } from '@/stores/index.js'
import { useBreakpoints, useEventListener } from '@vueuse/core'
import { debounce } from '@/utils/common.js'
import { breakpoints } from '@/utils/uiSetting.js'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import Empty from '@/components/common/Empty.vue'

// 获取配置信息
const appStore = useAppStore()
const { toggleDevice } = appStore
const { lang } = storeToRefs(appStore)

const antLocale = computed(() => (lang.value === 'zh-CN' ? zhCN : enUS))

const { locale } = useI18n()
locale.value = lang.value

// region 动态修改网站类型适应不同屏幕
const deviceBreakpoints = useBreakpoints(breakpoints)

const initDevice = () => {
  console.log('窗口大小改变')

  const deviceType = deviceBreakpoints.active().value
  let collapsed = undefined
  if (deviceBreakpoints.isInBetween('sm', 'xl')) {
    collapsed = true
  }
  if (deviceBreakpoints.isGreaterOrEqual('xl')) {
    collapsed = false
  }

  toggleDevice(deviceType, collapsed)
}

// 初始化执行一次
initDevice()

// 增加防抖监听
const debouncedInitDevice = debounce(initDevice, 200)
useEventListener('resize', debouncedInitDevice, { passive: true })
// endregion
</script>
